import apiService from "./apiService";
import {
  DYNAMIC_UI_TYPE_LIST,
  ITEM_PER_PAGE_DYNAMIC_ITEMS,
  SELECTED,
  TAB_ALL
} from "../../../pages/dynamicUi/constants";
import {isArray} from "lodash";
import {PLATFORM_BOTH, PLATFORM_MOBILE, PLATFORM_WEB} from "../../../constants/commons";


export const getDynamicItemsTest = () => {
  return new Promise((resolve, reject) => {

    setTimeout(() => {
      resolve({data: 23});
    }, 3000);

  });
};

export const getDynamicItems = () => {
  return apiService.get(URIS.sections);
};

export const getDynamicItemsPaginated = (type, page = 1,  tab, itemPerPage = ITEM_PER_PAGE_DYNAMIC_ITEMS) => {
  const params = {
    page: page,
    ...(type && type!==TAB_ALL && {type: type.toLowerCase()}),
    item_per_page: itemPerPage,
    selected: tab === SELECTED 
  };
  return apiService.get(URIS.sections, {params});
};
export const getSelectedItems = () => {
  return apiService.get(URIS.selected_sections);
};

export const  getSectionById = (sectionId) => {
  return apiService.get(URIS_D('section', sectionId));
};


export const getPageSelectedItems = (pageId) => {
  return apiService.get(URIS_D('page_selected_sections', pageId.substring(1)));
};

export const deleteDynamicItems = (id) => {
  return apiService.delete(URIS_D('section', id));
};

export const removeFromSelectedItems = (id) => {
  return apiService.delete(URIS_D('selected_section', id));
};

export const deleteSectionsFromPage = (pageId, selectedId) => {
  return apiService.delete(URIS_D('page_selected_section', pageId.substring(1), selectedId));
};

export const addToSelectedItems = (id, priority) => {
  const postData = {
    section_id: id,
    ...(priority && {priority})
  };
  return apiService.post(URIS.selected_sections, postData);
};

export const addSectionsToPage = (pageId, id, priority, isQuickee) => {
  const postData = {
    section_id: id,
    ...(priority && {priority}),
    ...(isQuickee !== undefined && {is_quickee: isQuickee})
  };
  return apiService.post(URIS_D('page_selected_sections', pageId.substring(1)), postData);
};

export const updatePriority = (id, priority) => {
  const postData = {
    priority
  };
  return apiService.patch(URIS_D('selected_section', id), postData);
};

export const patchPriorityOfPageSections = (pageId, id, priority, isQuickee) => {
  //todo this contains some quick fix related pageId fix it and remove this todo and *.substring(1) entries
  const postData = {
    priority,
    ...(isQuickee !== undefined && {is_quickee: isQuickee})
  };
  return apiService.patch(URIS_D('page_selected_section', pageId.substring(1), id), postData);
};

const prepareAddDynamicUiPostData = ({uiType, uiSubType, displayType, isDefault, data, platforms, extras}) => {
  return {
    type: uiType.value,
    extras,
    ...(uiSubType?.value && {sub_type: uiSubType.value}),
    ...(displayType && {display_type: displayType}),
    ...(isDefault !== undefined && {is_default: isDefault}),
    ...(data?.id && {value: `${data.id}`}),
    ...(isArray(platforms) && platforms.length &&
      {platform: platforms.some((p) => p.value === PLATFORM_WEB) && platforms.some((p) => p.value === PLATFORM_MOBILE) ? PLATFORM_BOTH : platforms[0].value}),
    ...(isArray(data) && data.length && {sections: data.map((d) => prepareAddDynamicUiPostData(d))})
  };
};

export const postDynamicItem = (data) => {
  // const postData = {
  //   type: uiType.value,
  //   ...(uiSubType?.value && {sub_type: uiSubType.value}),
  //   ...(displayType && {display_type: displayType}),
  //   ...(isDefault !== undefined && {is_default: isDefault}),
  //   ...(data?.id && {value: `${data.id}`}),
  //   ...(isArray(data) && data.length && {
  //     sections: data.map((d) => {
  //
  //     })
  //   })
  // };

  //todo remove all the comments later
  // const postData = {
  //   "type": "GROUP",
  //   "is_default": true,
  //   "sub_type": "HORIZONTAL",
  //   "sections": [
  //     {
  //       "type": "QUICK_LINK",
  //       "sub_type": "UPLOAD_PRESCRIPTION"
  //     },
  //     {
  //       "type": "QUICK_LINK",
  //       "sub_type": "CALL_PHARMACIST",
  //       "value": "555555"
  //     }
  //   ]
  // };
  // const postData = {
  //   "type": "QUICK_LINK",
  //   "sub_type": "CALL_CUSTOMER_CARE",
  //   "is_default": true,
  //
  // };
  // const postData = {
  //   "type": "QUICK_LINK",
  //   "sub_type": "BLOOD_GLUCOSE",
  //   "is_default": true
  //
  // };
  // const postData = {
  //   "type": "QUICK_LINK",
  //   "sub_type": "BLOOD_REQUEST",
  //   "is_default": true
  //
  // };


  return apiService.post(URIS.sections, prepareAddDynamicUiPostData(data));
};

export const putDynamicItem = (id, data) => {

  // id = "c2eb6bf9-04c4-44a2-b4b2-f1cdaec1447c";
  // const edit = {
  //   sections: [],
  //   type: "STATIC",
  //   id: "c2eb6bf9-04c4-44a2-b4b2-f1cdaec1447c",
  //   sub_type: "REFERRAL",
  //   is_default: true,
  //   platform: "MOBILE"
  // };


  return apiService.put(URIS_D('section', id), prepareAddDynamicUiPostData(data));
};

export const patchBulkUpdateItems = (itemList) => {
  return apiService.patch(URIS.selected_sections, itemList);
};
export const patchBulkUpdateItemsInPage = (pageId, itemList) => {
  return apiService.patch(URIS_D('page_selected_sections', pageId.substring(1)), itemList);
};

export const patchMetaInformation = (payload) => {
  return apiService.post(URIS.section_meta, payload);
};

export const postDefaultItem = () => {
  const promises = [];
  DYNAMIC_UI_TYPE_LIST.forEach((uiType) => {
    if (uiType.is_default) {
      uiType.sub_types.forEach((subType) => {
        // console.log({"type": uiType.value, sub_type: subType.value, is_default: true});
        promises.push(apiService.post(URIS.sections,
          {"type": uiType.value, sub_type: subType.value, is_default: true}));
        // promises.push({"type": uiType.value, sub_type: subType.value, is_default: true});
      });
    } else {
      uiType.sub_types.forEach((subType) => {
        if (subType.is_default) {
          promises.push(apiService.post(URIS.sections,
            {"type": uiType.value, sub_type: subType.value, is_default: true}));
          // promises.push({"type": uiType.value, sub_type: subType.value, is_default: true})
        }
      });
    }

  });
  // console.log(promises)
  return Promise.all(promises);
};


const URIS_D = (url, param1, param2) => {
  return {
    selected_section: `${URIS.selected_sections}/${param1}`,
    section: `${URIS.sections}/${param1}`,
    page_selected_sections: `/v1/cms/pages/${param1}/selected-sections`,
    page_selected_section: `/v1/cms/pages/${param1}/selected-sections/${param2}`
  }[url];
};

const URIS = {
  sections: '/v1/cms/sections',
  selected_sections: '/v1/cms/selected-sections',
  section_meta: '/v1/cms/section-title',

};

